import React from "react";
import { Link } from "react-router-dom";
import "../css/components/Footer.css";

import facebookIcon from "../assets/Icons/facebook-white.png";
import instagramIcon from "../assets/Icons/instagram-white.png";
import tiktokIcon from "../assets/Icons/tiktok-white.png";
import linkedinIcon from "../assets/Icons/linkedin-white.png";
import contactusIcon from "../assets/Icons/contactus-white.png";

function Footer() {
  return (
    <footer className="footer-light-gradient ultra-minimal-footer">
      <div className="footer-ultra-row">
        {/* Contact */}
        <div className="footer-ultra-col footer-ultra-contact">
          <a
            href="mailto:collegenav.info@gmail.com"
            className="footer-email ultra-footer-email"
            title="Email"
          >
            <img
              src={contactusIcon}
              alt="Email"
              className="footer-ultra-email-icon"
            />
            collegenav.info@gmail.com
          </a>
        </div>
        <div className="footer-ultra-divider" />
        {/* Social */}
        <div className="footer-ultra-col footer-ultra-social">
          <a
            href="https://www.linkedin.com/company/college-nav/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-btn"
            title="LinkedIn"
          >
            <img src={linkedinIcon} alt="LinkedIn" />
          </a>
          <a
            href="https://www.facebook.com/people/Collegenavinfo/61565326201320/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-btn"
            title="Facebook"
          >
            <img src={facebookIcon} alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/collegenav.info/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-btn"
            title="Instagram"
          >
            <img src={instagramIcon} alt="Instagram" />
          </a>
          <a
            href="https://www.tiktok.com/@collegenav"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon-btn"
            title="TikTok"
          >
            <img src={tiktokIcon} alt="TikTok" />
          </a>
        </div>
        <div className="footer-ultra-divider" />
        {/* Legal */}
        <div className="footer-ultra-col footer-ultra-legal">
          <Link to="/privacy-policy" className="footer-nav-link">
            Privacy Policy
          </Link>
          <span className="footer-nav-divider">|</span>
          <Link to="/terms-of-service" className="footer-nav-link">
            Terms of Service
          </Link>
        </div>
      </div>
      <div className="footer-ultra-legal-row">
        <p className="footer-disclaimer ultra-footer-disclaimer">
          By using this website, you agree to our Terms of Use and Privacy
          Policy. The information provided is for informational purposes only
          and may not be fully accurate or complete.
        </p>
        <p className="footer-copyright ultra-footer-copyright">
          © 2025 CollegeNav. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
